import { DateInputPM } from '@/components/DateInput'
import { TreeSelect } from '@/ui/Select'
import styles from './AreasSelect.module.scss'
import { useAreaStore } from '../store'
import { useGetAreas } from '../api/useGetAreas'

export const AreaSelect = () => {
    const { data: areas } = useGetAreas()
    const { selectedAreaCode, setSelectedAreaCode } = useAreaStore()

    const areaOptions = areas?.map((area) => ({ value: area.code, label: area.title })) || []

    const handleAreaChange = (value: string) => {
        setSelectedAreaCode(value)
    }

    return (
        <TreeSelect
            placeholder="Areas"
            options={[{ value: 'all', label: 'All areas' }, ...areaOptions, { value: 'night', label: 'Night Network' }]}
            value={selectedAreaCode}
            disabled={false}
            onChange={handleAreaChange}
        />
    )
}

export const AreasSelect = () => {
    return (
        <div className={styles.header}>
            <AreaSelect />
            <DateInputPM isIndexPage={true} />
        </div>
    )
}
